const MessageStatus = ({ message, isFromCurrentUser }) => {
    if (!isFromCurrentUser) return null;

    // ✅ Decide color
    const seenColor =
        message.text
            ? "#FFFFFF"     // text message tick color
            : "#327691";    // media message tick color


    // not seen yet
    if (!message.seen) {
        return (
            <span className="text-gray-400 text-xs ml-1">
                ✓
            </span>
        );
    }

    // ✅ Seen → Zylen Blue Tick
    return (
        <span className="ml-1">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M1 13L5 17L13 9"
                    stroke={seenColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13L12 17L23 6"
                    stroke={seenColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};


const GroupMessageStatus = ({
    message,
    isFromCurrentUser,
    totalMembers
}) => {

    if (!isFromCurrentUser) return null;

    const seenCount =
        message.seenBy
            ? Object.keys(message.seenBy).length
            : 0;

    const allSeen = seenCount >= totalMembers - 1;
    // minus sender

    // ✅ Decide color
    const seenColor =
        message.text
            ? "#ffffff"     // text grey 400
            : "#327691";    // text primary

    if (!allSeen) {
        return (
            <span className="text-gray-400 text-xs ml-1">
                ✓
            </span>
        );
    }

    return (
        <span className="ml-1">
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M1 13L5 17L13 9"
                    stroke={seenColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 13L12 17L23 6"
                    stroke={seenColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export { MessageStatus, GroupMessageStatus };